<template>
  <div :style="containerStyle">
    <img :src="assetUrl(theme.logo[deviceRange].src)" :height="theme.logo[deviceRange].height" :style="containerStyle" style="position: absolute" />
    <div v-if="isNotProd" class="flag">{{ stage }}</div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'LogoLarge',
  mixins: [common],

  props: {
    height: {
      type: Number,
      default: 40,
    },
    heightSmAndUp: {
      type: Number,
      default: 60,
    },
    color: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      customerRelations: (state) => state.profile.customerRelations,
    }),
    tenant() {
      return this.customerRelations.tenant;
    },
    containerStyle() {
      return `overflow:hidden;height:${this.theme.logo[this.deviceRange].height}px;${this.theme.logo[this.deviceRange].style}`;
    },
    stage() {
      return this.$store.state.configs.stage ? this.$store.state.configs.stage.toUpperCase() : 'unknown';
    },
    isNotProd() {
      if (this.tenant === 'demoapp') return false;
      return this.$store.state.configs.stage !== 'prod';
    },
  },
};
</script>
<style scoped>
.flag {
  position: absolute;
  font-weight: bold;
  background: rgb(255, 193, 7);
  height: 15px;
  width: 60px;
  font-size: 10px;
  text-align: center;
  transform: rotate(-45deg) translate(-15px, -8px);
}
</style>
